<template>
  <CrudList
    title="Guards"
    storeName="Guards"
    labelAddNew="Add new guard"
    :canAdd="role && role === 'admin' ? true : false"
    :canShow="role && role === 'admin_enterprise' ? true : false"
    :labelShow="role && role === 'admin_enterprise' ? true : false"
    slot-scope="{ item }"
    sortable
    canSearch
  >
    <template v-slot:profile_picture="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-list-item-avatar v-if="item.profile_picture">
            <img :src="item.profile_picture" alt=""/>
          </v-list-item-avatar>
        </v-col>
      </v-row>
    </template>
  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";
import { mapState } from "vuex";

export default {
  components: { CrudList },
  computed: {
    ...mapState({
      role: state => state.Authenticate.role
    })
  }
};
</script>
